import { type LocaleCode, LOCALES_DEFINITION } from '@repo/shared-config/app/constants/locales';
import enMessages from '../../translations/en.json' with { type: 'json' };
import frMessages from '../../translations/fr.json' with { type: 'json' };
import deMessages from '../../translations/de.json' with { type: 'json' };
import esMessages from '../../translations/es.json' with { type: 'json' };
import itMessages from '../../translations/it.json' with { type: 'json' };
import ptMessages from '../../translations/pt.json' with { type: 'json' };
import nlMessages from '../../translations/nl.json' with { type: 'json' };

export function loadMessages({ locale }: { locale: LocaleCode }): Record<string, string> {
  switch (locale) {
    case LOCALES_DEFINITION.FR.code:
      return frMessages;
    case LOCALES_DEFINITION.DE.code:
      return deMessages;
    case LOCALES_DEFINITION.ES.code:
      return esMessages;
    case LOCALES_DEFINITION.IT.code:
      return itMessages;
    case LOCALES_DEFINITION.PT.code:
      return ptMessages;
    case LOCALES_DEFINITION.NL.code:
      return nlMessages;
    case LOCALES_DEFINITION.EN.code:
    default:
      return enMessages;
  }
}
